import { render, staticRenderFns } from "./AcceptedQuotes.vue?vue&type=template&id=639bd280"
import script from "./AcceptedQuotes.vue?vue&type=script&lang=js"
export * from "./AcceptedQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports